import Hero from "../components/home/Hero";
import Portfolio from "../components/home/Portfolio";
import TechStack from "../components/home/TechStack";
import About from "../components/About";
import AboutAndProcess from "../components/home/AboutAndProcess";
import WhyChooseUs from "../components/home/WhyChooseUs";
import FAQ from "../components/home/FAQ";
import CTABanner from "../components/home/CTABanner";
import Contact from "../components/home/Contact";
import Footer from "../components/home/Footer";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (!location.state?.scrollTo) return;

    const timer = setTimeout(() => {
      const section = document.getElementById(location.state.scrollTo);

      if (section) {
        const y = section.offsetTop - 80;

        window.scrollTo({
          top: y,
          behavior: "auto", // instant jump, no visible scrolling animation
        });

        // Clear the state so it doesn't scroll again on re-render
        window.history.replaceState({}, document.title);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <>
      <Hero />
      <Portfolio />
      <TechStack />
      <AboutAndProcess />
      <WhyChooseUs />
      <FAQ />
      <CTABanner />
      <Contact />
      <Footer />
    </>
  );
}